import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "r-minus",
  "use": "r-minus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"r-minus\">\n<path d=\"M2.50391 8.33203H13.4985C13.7747 8.33203 13.9985 8.10816 13.9985 7.83203C13.9985 7.5559 13.7747 7.33203 13.4985 7.33203H2.50391C2.22777 7.33203 2.00391 7.5559 2.00391 7.83203C2.00391 8.10816 2.22777 8.33203 2.50391 8.33203Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol